// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"6b460d46bcba05d2ede7","263":"7344fd1cc1316959bffb","791":"edf66763f03175fa434e"}[chunkId] + ".js";
};